class ProductFormManager {
  constructor() {
    this.initEventListeners();
    this.cleanRatingSnippet();
    this.preOrderProperties();
  }

  initEventListeners() {
    // Handle subscription change event
    $(document).on('change', 'input[name="subscription"]', (e) => this.handleSubscriptionChange(e));
    $('.product_total').css('opacity', '1');
    $('.product-header-cart_btn, .product_sticky_cart_btn').removeAttr('disabled');
  
    // Handle flavor selection
    $(document).on('click', '.button_tablinks_flavor', (e) => this.handleFlavorSelection(e));

    // Handle quantity change
    $('.quantity-select').on('change', () => this.handleQuantityChange());

    // Handle add to cart button click
    $(document).on('click', '#product-form-new button[type=submit], .product_sticky_cart_btn', (e) => this.handleAddToCart(e));

    // Info Popup
    $('.subscription_benefits').on('click', () => this.showInfoPopup());
     // this.updateTotal();
  }

  handleSubscriptionChange(event) {
    // Remove green border from all cards
    $('.subscription_card').removeClass('active_sub');

    // Add green border to the selected (checked) radio's parent card
    if ($(event.target).is(':checked')) {
      $(event.target).closest('.subscription_card').addClass('active_sub');
    }

    // Disable/enable selling plan input based on subscription selection
    if ($(event.target).val() === 'onetime') {
      $('input[name=selling_plan]').attr('disabled', 'disabled');
    } else {
      $('input[name=selling_plan]').removeAttr('disabled');
    }

    this.calculateTotal();
  }

  handleFlavorSelection(event) {
    const selectedCard = $(event.target).closest('.flavor_card');
    let variantID = selectedCard.attr('data-variant-id');

    if (!variantID) {
      console.error('Variant ID not found for the selected flavor card.');
      return;
    }
    const allQtyDropdowns = document.querySelectorAll(".flavor_card .selector_flavor .quantity-select");
    
    allQtyDropdowns.forEach((dropdown) => {
        const parentCard = dropdown.closest(".flavor_card"); // Find the closest .flavor_card parent
          
        if (parentCard && parentCard.dataset.variantId === variantID) {
            dropdown.value = "1"; // Set value to 1 for the matching variant
          this.updateTotal();
        } else {
            dropdown.value = "0"; // Set value to 0 for non-matching variants
           this.updateTotal();
        }
     
    });
    if ($('input[name="subscription"]:checked').val() === 'onetime') {
      selectedCard.find('input[name=selling_plan]').attr('disabled', 'disabled');
    }

    $('.flavor_card').removeClass('active');
    selectedCard.addClass('active');
    
    this.preOrderProperties();
    
    // Match other elements that have variant selectors
    const tablinks = $(`.tablinks_flavor[data-variant-id=${variantID}]`)[0];
    if (tablinks) {
      tablinks.click(); // Only click if the element exists
    }
    
    $('.modern-variants [data-variant-id]').hide();
    $(`.modern-variants [data-variant-id=${variantID}]`).show();
    $('.benefits-video [data-variant-id]').hide();
    $(`.benefits-video [data-variant-id=${variantID}]`).show();

    // Sync with modal if needed
    let fRefresh = setInterval(() => {
      if ($('.supplement-modal #supplement').length > 0) {
        let activeVariantID = $('.flavor_card.active').attr('data-variant-id');
        $(`.supplement-modal .tablinks_flavor[data-variant-id=${activeVariantID}]`)[0].click();
        clearInterval(fRefresh);
      }
    }, 10);

   this.updateVisibility(variantID);
  }

  updateVisibility(variantID) {
    const elements = document.querySelectorAll('[data-show]');
    elements.forEach(element => {
        if (element.getAttribute('data-show') == variantID) {
            element.style.display = 'flex';
        } else {
            element.style.display = 'none';
        }
    });
  }
  
  handleQuantityChange() {
    let hasQuantity = false;
    const isMobile = window.innerWidth <= 768;
    
    $('.quantity-select').each(function() {
      if ($(this).val() > 0) {
        hasQuantity = true;
      }
    });

    if (hasQuantity) {
      $('.product-header-cart_btn, .product_sticky_cart_btn').removeAttr('disabled');
      $('.product_total').css('opacity', '1');
    } else {
      if(!isMobile){
        $('.product-header-cart_btn, .product_sticky_cart_btn').attr('disabled', 'disabled');
      }
      
      // $('.product_total').css('opacity', '0');
    }

    this.calculateTotal();
  }

  calculateTotal() {
    let defaultTotal = 0;
    let subscriptionTotal = 0;
    let subscription = $('input[name="subscription"]:checked').val();
    let productTotal = $('.product_total');
    let subscriptionOptionActive = $('.option-button.active');
    let subscriptionOptionButton = $('.option-button[data-val="subscription"]');
    let onetimeOptionButton = $('.option-button[data-val="onetime"]');
    
    $('.flavor_card').each(function() {
      let sellingPlan = ($(this).find('input[name=selling_plan]').prop('disabled')) ? '' : $(this).find('input[name=selling_plan]').val();
      let quantity = $(this).find('select[name=quantity]').val();
      let price = $('select[name=quantity]').attr('data-price');
      let sellingPlanPrice = $('select[name=quantity]').attr('data-selling-plan-price');

      defaultTotal += (quantity * price);
      subscriptionTotal += (quantity * sellingPlanPrice);
    });

    if (subscription === 'subscription') {
      productTotal.html(`
        <span>You're saving <span class="product_saving">${Shopify.formatMoney(defaultTotal - subscriptionTotal)}</span></span>
        <span class="product_total-price"><span class="strike">${Shopify.formatMoney(defaultTotal)}</span>${Shopify.formatMoney(subscriptionTotal)}</span>
      `);
      
    } else {
      productTotal.html(`
        <span>Your total</span>
        <span class="product_total-price">${Shopify.formatMoney(defaultTotal)}</span>
      `);

    }

 
    if(defaultTotal<1){
      subscriptionOptionButton.find('.main-price').text(subscriptionOptionButton.find('.main-price').data('price'));
      subscriptionOptionButton.find('.regular-price').text(subscriptionOptionButton.find('.regular-price').data('price'));
      onetimeOptionButton.find('.main-price').text(onetimeOptionButton.find('.main-price').data('price'));
    }
    else{
      subscriptionOptionButton.find('.main-price').text(this.formatMoney(subscriptionTotal));
      subscriptionOptionButton.find('.regular-price').text(this.formatMoney(defaultTotal));
      onetimeOptionButton.find('.main-price').text(this.formatMoney(defaultTotal));
    }

    if(subscriptionOptionActive){
      subscriptionOptionActive.click();
    }
  }

  updateTotal() {
    let updatedDefaultTotal = 0;
    let updatedSubscriptionTotal = 0;
    let productTotal = $('.product_total');
    let subscription = $('input[name="subscription"]:checked').val();
    let subscriptionOptionActive = $('.option-button.active');
    let subscriptionOptionButton = $('.option-button[data-val="subscription"]');
    let onetimeOptionButton = $('.option-button[data-val="onetime"]');

    
    $('.flavor_card').each(function() {
      let sellingPlan = ($(this).find('input[name=selling_plan]').prop('disabled')) ? '' : $(this).find('input[name=selling_plan]').val();
      let quantity = $(this).find('select[name=quantity]').val();
      let price =  $(this).find('select[name=quantity]').attr('data-price');
      let sellingPlanPrice =  $(this).find('select[name=quantity]').attr('data-selling-plan-price');
       if(quantity>0){
          updatedDefaultTotal = quantity * price;
          updatedSubscriptionTotal = quantity * sellingPlanPrice;
       }
    });

    
    if (subscription === 'subscription') {
      productTotal.html(`
        <span>You're saving <span class="product_saving">${Shopify.formatMoney(updatedDefaultTotal - updatedSubscriptionTotal)}</span></span>
        <span class="product_total-price"><span class="strike">${Shopify.formatMoney(updatedDefaultTotal)}</span>${Shopify.formatMoney(updatedSubscriptionTotal)}</span>
      `);
      
    } else {
      productTotal.html(`
        <span>Your total</span>
        <span class="product_total-price">${Shopify.formatMoney(updatedDefaultTotal)}</span>
      `);

    }
    if(updatedDefaultTotal<1){
      subscriptionOptionButton.find('.main-price').text(subscriptionOptionButton.find('.main-price').data('price'));
      subscriptionOptionButton.find('.regular-price').text(subscriptionOptionButton.find('.regular-price').data('price'));
      onetimeOptionButton.find('.main-price').text(onetimeOptionButton.find('.main-price').data('price'));
    }
    else{
      subscriptionOptionButton.find('.main-price').text(this.formatMoney(updatedSubscriptionTotal));
      subscriptionOptionButton.find('.regular-price').text(this.formatMoney(updatedDefaultTotal));
      onetimeOptionButton.find('.main-price').text(this.formatMoney(updatedDefaultTotal));
    }

    if(subscriptionOptionActive){
      subscriptionOptionActive.click();
    }
  }
  // Custom function to format money without decimals
  formatMoney(amount) {
    // Format money and remove .00
    const formatted = Shopify.formatMoney(amount);
    return formatted.replace(/\.00$/, ''); // Remove .00 if it exists
  }
  
  areAllQuantitiesZero() {
    // Get all .quantity-select elements
    const selects = $('.quantity-select');
  
    // Check if all values are '0'
    const allZero = selects.toArray().every(select => $(select).val() === '0');
  
    return allZero;
  }
  
  getActiveVariantId() {
    // Find the active flavor_card and get its data-variant-id
    const activeVariantId = $('.flavor_card.active').data('variant-id');
    return activeVariantId;
  }
  
  getActiveVariantDetails() {
      // Find the active flavor_card
      const activeCard = $('.flavor_card.active');
      
      if (activeCard.length === 0) {
          return {
              variantId: '',
              sellingPlan: ''
          };
      }
  
      // Get the data-variant-id
      const variantId = activeCard.data('variant-id');
  
      // Get the input[name=selling_plan] and check if it is disabled
      const sellingPlanInput = activeCard.find('input[name="selling_plan"]');
      const sellingPlan = sellingPlanInput.is(':disabled') ? '' : sellingPlanInput.val();
  
      return {
          variantId,
          sellingPlan
      };
  }

  handleAddToCart(event) {
    event.preventDefault();

    let atc = $(event.target);
    let _cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    atc.attr('disabled', 'disabled');

    let formData = {
      'items': [],
      'sections': _cart.getSectionsToRender().map((section) => section.id),
      'sections_url': window.location.pathname
    };

    $('.flavor_card').each(function() {
      let sellingPlan = ($(this).find('input[name=selling_plan]').prop('disabled')) ? '' : $(this).find('input[name=selling_plan]').val();
      let variantID = $(this).find('input[name=id]').val();
      let quantity = $(this).find('select[name=quantity]').val();
      
      // Add custom properties
      const backorder = document.getElementById('backorder-data');
      let variantData = null;
      
      if(backorder){
        let backorderData = JSON.parse(backorder.textContent);
        variantData = backorderData.FABRIKATOR_BACKORDER_VARIANTS_SECTION_PAYLOAD.find(item => item.id === variantID);
      }

     
      let fabrikatorPreorder = variantData?.backorder_id;
      let fabrikatorNote = variantData?.shipment_note;
      
      formData.items.push({
        id: variantID,
        quantity: quantity,
        selling_plan: sellingPlan,
        properties: {
          _is_fabrikator_preorder: fabrikatorPreorder, // Add preorder property
          Note: fabrikatorNote // Add note property
        }
      });
    });


    
    const isStickyCartButton = $(event.target).hasClass('product_sticky_cart_btn');
   
    const isMobile = window.innerWidth <= 768; 

    if (isStickyCartButton && isMobile && this.areAllQuantitiesZero()) {
      formData.items.push({
        id: this.getActiveVariantDetails().variantId,
        quantity: 1,
        selling_plan: this.getActiveVariantDetails().sellingPlan
      });
    } 
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(response => {
      response.items.forEach(item => {
        item['sections'] = response.sections;
        _cart.renderContents(item);
      });
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      atc.removeAttr('disabled');
      if (_cart && _cart.classList.contains('is-empty')) _cart.classList.remove('is-empty');
    });
  }
  
  preOrderProperties(){
    const variant = document.querySelector('.flavor_card.active');
    const variantId = document.querySelector('.flavor_card.active').getAttribute("data-variant-id");

    const backorder = document.getElementById('backorder-data');
    let variantData = null;
    
    if(backorder){
      let backorderData = JSON.parse(backorder.textContent);
       variantData = backorderData.FABRIKATOR_BACKORDER_VARIANTS_SECTION_PAYLOAD.find(item => item.id === variantId);
    }

    if (variantData != null ) {
      const submitButton = document.querySelector('.product-header-cart_btn');
      const preOrderLabel = submitButton.getAttribute('data-pre-order-label');
      if (preOrderLabel) {
        submitButton.textContent = preOrderLabel;
      }
    } 
    else{
      const submitButton = document.querySelector('.product-header-cart_btn');
      const cartSubmitButton = document.querySelector('.product_sticky_cart_btn');
      const addToCartLabel = submitButton.getAttribute('data-add-to-cart-label');
      const soldOutLabel = submitButton.getAttribute('data-sold-out-label');
      if (submitButton && variant.hasAttribute('data-available')) {
        submitButton.textContent = addToCartLabel;
        cartSubmitButton.textContent = addToCartLabel;
      } else {
        submitButton.textContent = soldOutLabel;
        cartSubmitButton.textContent = soldOutLabel;
      }

    }
  }
  
  cleanRatingSnippet() {
    var rukRefresh = setInterval(() => {
      var reviewElement = $(".ruk-rating-snippet-count");
      if (reviewElement.length && /\(|\)/.test(reviewElement.text())) {
        reviewElement.text(reviewElement.text().replace(/\(|\)/g, ''));
        setTimeout(() => {
          clearInterval(rukRefresh);
        }, 400);
      }
    }, 10);
  }

  showInfoPopup() {
    $('.gm-info-popup').show();
    $('.gm-info-popup .gm-popup-launch').click(); 
  }

}

$(document).ready(() => {
  new ProductFormManager();
});